import { CircleAlert, CircleCheck } from 'lucide-react';

export function Notice({ tone = 'info', children }: { tone?: 'info' | 'success' | 'warning' | 'danger'; children: string }) {
  return <div className={`notice notice--${tone}`} role="status">{tone === 'success' ? <CircleCheck /> : <CircleAlert />}<span>{children}</span></div>;
}
